var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17 18.4299H13L8.54999 21.39C7.88999 21.83 7 21.3599 7 20.5599V18.4299C4 18.4299 2 16.4299 2 13.4299V7.42993C2 4.42993 4 2.42993 7 2.42993H17C20 2.42993 22 4.42993 22 7.42993V13.4299C22 16.4299 20 18.4299 17 18.4299Z",
    fill: "#d9e4f8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.11C11.59 12.11 11.25 11.77 11.25 11.36V11.15C11.25 9.99002 12.1 9.42001 12.42 9.20001C12.79 8.95001 12.91 8.78002 12.91 8.52002C12.91 8.02002 12.5 7.60999 12 7.60999C11.5 7.60999 11.09 8.02002 11.09 8.52002C11.09 8.93002 10.75 9.27002 10.34 9.27002C9.93003 9.27002 9.59003 8.93002 9.59003 8.52002C9.59003 7.19002 10.67 6.10999 12 6.10999C13.33 6.10999 14.41 7.19002 14.41 8.52002C14.41 9.66002 13.57 10.23 13.26 10.44C12.87 10.7 12.75 10.87 12.75 11.15V11.36C12.75 11.78 12.41 12.11 12 12.11Z",
    fill: "#437adb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.6C11.58 14.6 11.25 14.26 11.25 13.85C11.25 13.44 11.59 13.1 12 13.1C12.41 13.1 12.75 13.44 12.75 13.85C12.75 14.26 12.42 14.6 12 14.6Z",
    fill: "#437adb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestion);
export default __webpack_public_path__ + "static/media/message-question.fd97231b3dd7a5785dbb79bc9dce1150.svg";
export { ForwardRef as ReactComponent };